// src/components/Header.js
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
        document.body.classList.toggle('scrolled', isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

    useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="logo">
        <Link to="/">
          <img
            src={scrolled ? "/assets/images/A.png" : "/assets/images/Andolfatto Logo.png"}
            alt="Andolfatto Insurance Broker Logo"
          />
        </Link>
      </div>

      {/* Bottone hamburger (visibile solo su mobile) */}
      <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Navigazione */}
      <nav className={`nav ${menuOpen ? 'open' : ''} ${scrolled ? 'scrolled' : ''}`}>
        <ul>
          <li>
            <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/chi-siamo" className={location.pathname === '/chi-siamo' ? 'active' : ''}>
              Chi Siamo
            </Link>
          </li>
          <li>
            <Link to="/il-nostro-metodo" className={location.pathname === '/il-nostro-metodo' ? 'active' : ''}>
              Il Nostro Metodo
            </Link>
          </li>
          <li>
            <Link to="/polizze-assicurative" className={location.pathname === '/polizze-assicurative' ? 'active' : ''}>
              Polizze Assicurative
            </Link>
          </li>
          <li>
            <Link to="/contatti" className={location.pathname === '/contatti' ? 'active' : ''}>
              Contatti
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
